module.exports = __webpack_public_path__ + "assets/rider_balance_negative.b8a8e68f.svg";